/* Vehicle details for theme-owned product forms. No checkout or app hooks. */
(() => {
  const label = 'Submit vehicle details and Buy Now';
  const fieldSelector = '[data-du-reference-fields] input[name^="properties["], [class*="ai-fitment-fields-"] input[name^="properties["]';
  const addSelector = '[data-btn-addtocart], button[name="add"], input[name="add"]';
  const registry = new Map(JSON.parse(document.getElementById('du-fitment-products')?.textContent || '[]')
    .filter(product => product.id && product.url).map(product => [String(product.id), product.url]));

  function identity(form) {
    const context = form.querySelector('[data-du-form-product]');
    return context?.dataset.duFormProduct || form.dataset.productId || form.closest('[data-product-id]')?.dataset.productId;
  }
  function fieldsFor(form) {
    const id = identity(form);
    return Array.from(document.querySelectorAll(fieldSelector)).filter(field => {
      const fieldId = field.closest('[data-du-product-id]')?.dataset.duProductId;
      if (fieldId) return fieldId === id;
      const scope = field.closest('.productView, .shopify-section');
      return field.form === form || (scope && scope.contains(form));
    }).filter(field => !field.disabled);
  }
  function initialise(form) {
    const fields = fieldsFor(form);
    const needed = registry.has(identity(form)) || fields.length > 0;
    if (!needed) return;
    fields.forEach(field => {
      field.required = true;
      field.setAttribute('aria-required', 'true');
    });
    form.querySelectorAll(addSelector).forEach(button => {
      button.classList.add('du-fitment-button');
      // Preserve unavailable, preorder and loading feedback supplied by the theme.
      if (button.disabled || button.classList.contains('is-loading') || button.classList.contains('loading') || button.classList.contains('is-soldout') || button.classList.contains('is-notify-me')) return;
      const text = (button.value || button.textContent).trim();
      const ordinary = [window.variantStrings?.addToCart, window.variantStrings?.submit, 'Buy Now', 'Buy Now', label]
        .filter(Boolean).some(value => text.toLowerCase() === value.toLowerCase()) || /^Buy Now\b/i.test(text);
      if (!ordinary) return;
      if (button.tagName === 'INPUT') button.value = label;
      else if (button.textContent !== label) button.textContent = label;
    });
  }
  function prepare(form) {
    const fields = fieldsFor(form);
    if (!fields.length) {
      const url = registry.get(identity(form));
      if (url) {
        // Quick-add cannot collect these details. Open the full product form.
        window.location.assign(url + '#du-vehicle-description');
        return false;
      }
      return true;
    }
    let invalid;
    fields.forEach(field => {
      field.required = true;
      field.setCustomValidity(field.value.trim() ? '' : 'Please enter this vehicle detail before adding to cart.');
      field.setAttribute('aria-invalid', String(!field.validity.valid));
      if (!field.validity.valid && !invalid) invalid = field;
    });
    if (invalid) {
      document.body.classList.remove('show-mobile-options');
      invalid.scrollIntoView({block: 'center', behavior: 'smooth'});
      invalid.focus({preventScroll: true});
      invalid.reportValidity();
      return false;
    }
    form.querySelectorAll('[data-du-property-copy]').forEach(input => input.remove());
    fields.forEach(field => {
      // Sticky forms need their own copies; main fields use HTML form association.
      if (field.form === form) return;
      const copy = document.createElement('input');
      copy.type = 'hidden';
      copy.name = field.name;
      copy.value = field.value.trim();
      copy.dataset.duPropertyCopy = '';
      form.append(copy);
    });
    return true;
  }
  document.addEventListener('input', event => {
    if (!event.target.matches(fieldSelector)) return;
    event.target.setCustomValidity('');
    event.target.removeAttribute('aria-invalid');
  });
  document.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key) || !event.target.matches('[data-fancybox="images"][role="button"]')) return;
    event.preventDefault();
    event.target.click();
  });
  document.addEventListener('click', event => {
    const button = event.target.closest(addSelector);
    const form = button?.closest('form');
    if (!form || button.disabled || button.classList.contains('is-notify-me') || button.classList.contains('is-soldout')) return;
    if (!prepare(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    if (!prepare(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  // Variant changes and quick-view rendering replace labels and forms.
  let scheduled = false;
  const refresh = () => {
    scheduled = false;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(initialise);
  };
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']});
  refresh();
})();
